// standard moment-timezone imports moment from node_modules...
module.exports = require('moment-timezone/builds/moment-timezone-with-data-10-year-range')
